import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Calendar, Clock, Users } from 'lucide-react';
export function Programs() {
  const {
    ref,
    inView
  } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });
  // Calculate time until January 4th, 2026
  const getTimeUntilNextEvent = () => {
    const now = new Date();
    const targetDate = new Date('2026-01-04T00:00:00');
    const timeDiff = targetDate.getTime() - now.getTime();
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor(timeDiff % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    const minutes = Math.floor(timeDiff % (1000 * 60 * 60) / (1000 * 60));
    return {
      days,
      hours,
      minutes
    };
  };
  const {
    days,
    hours,
    minutes
  } = getTimeUntilNextEvent();
  return <section id="programs" className="py-20 bg-white" data-id="element-266">
      <div className="container mx-auto px-4" data-id="element-267">
        <div className="text-center mb-12" data-id="element-268">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-269">
            Programs & Schedule
          </h2>
          <div className="w-24 h-1 bg-pink-600 mx-auto" data-id="element-270"></div>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-271">
            Join us weekly as we gather to learn, grow, and empower one another
            through God's Word.
          </p>
        </div>

        <div ref={ref} className={`transition-all duration-1000 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-272">
          {/* Weekly Broadcast Card */}
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-273">
            <div className="md:flex" data-id="element-274">
              <div className="md:w-1/3 bg-pink-600 text-white p-8 flex flex-col justify-center items-center" data-id="element-275">
                <h3 className="text-2xl font-bold mb-4" data-id="element-276">Weekly Broadcast</h3>
                <div className="text-center" data-id="element-277">
                  <div className="flex items-center justify-center mb-2" data-id="element-278">
                    <Calendar className="mr-2" size={20} data-id="element-279" />
                    <span data-id="element-280">Every Sunday</span>
                  </div>
                  <div className="flex items-center justify-center mb-2" data-id="element-281">
                    <Clock className="mr-2" size={20} data-id="element-282" />
                    <span data-id="element-283">8:00 PM - 8:30 PM</span>
                  </div>
                </div>
              </div>
              <div className="md:w-2/3 p-8" data-id="element-284">
                <h4 className="text-xl font-semibold mb-4" data-id="element-285">
                  First Broadcast Countdown
                </h4>
                <div className="flex justify-center space-x-4 mb-6" data-id="element-286">
                  <div className="text-center" data-id="element-287">
                    <div className="text-3xl font-bold text-pink-600" data-id="element-288">
                      {days}
                    </div>
                    <div className="text-gray-600" data-id="element-289">Days</div>
                  </div>
                  <div className="text-center" data-id="element-290">
                    <div className="text-3xl font-bold text-pink-600" data-id="element-291">
                      {hours}
                    </div>
                    <div className="text-gray-600" data-id="element-292">Hours</div>
                  </div>
                  <div className="text-center" data-id="element-293">
                    <div className="text-3xl font-bold text-pink-600" data-id="element-294">
                      {minutes}
                    </div>
                    <div className="text-gray-600" data-id="element-295">Minutes</div>
                  </div>
                </div>
                <h4 className="text-xl font-semibold mb-2" data-id="element-296">Activities</h4>
                <ul className="space-y-2" data-id="element-297">
                  <li className="flex items-center" data-id="element-298">
                    <div data-id="element-299">The Word</div>
                  </li>
                  <li className="flex items-center" data-id="element-300">
                    <div data-id="element-301">Prayer</div>
                  </li>
                  <li className="flex items-center" data-id="element-302">
                    <div data-id="element-303">Prophetic</div>
                  </li>
                  <li className="flex items-center" data-id="element-304">
                    <div data-id="element-305">Announcements</div>
                  </li>
                </ul>
                <div className="mt-6" data-id="element-306">
                  <a href="#" className="bg-pink-600 hover:bg-pink-700 text-white font-medium py-2 px-6 rounded-full inline-flex items-center transition-colors duration-200" data-id="element-307">
                    <Users size={18} className="mr-2" data-id="element-308" />
                    Join Next Broadcast
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Services */}
          <div className="mt-16" data-id="element-309">
            <h3 className="text-2xl font-bold text-center mb-8" data-id="element-310">
              Additional Services
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-311">
              <ServiceCard title="Special Prayer Line" data-id="element-312" />
              <ServiceCard title="Private Q&A Session" data-id="element-313" />
              <ServiceCard title="Personal Consultation" data-id="element-314" />
              <ServiceCard title="Counseling" data-id="element-315" />
              <ServiceCard title="Online Newsletter" data-id="element-316" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function ServiceCard({
  title
}) {
  return <div className="bg-white rounded-lg shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300" data-id="element-317">
      <h4 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-318">{title}</h4>
      <p className="text-gray-600" data-id="element-319">
        Connect with us to learn more about this service.
      </p>
    </div>;
}